const platforms = [
  {
    id: 'booking',
    homeUrl: process.env.REACT_APP_BOOKING_HOME_URI,
    displayOnHomepage: false
  },
  {
    id: 'decipher',
    title: 'Decipher',
    displayOnHomepage: true,
    loginUrl: 'https://selfserve.decipherinc.com/login',
    signupUrl: `/sign-up?client_id=decipher&confirmation_uri=/login/confirmation&hostname=${
      process.env.REACT_APP_DECIPHER_HOSTNAME
    }&redirect_uri=${encodeURIComponent(
      process.env.REACT_APP_DECIPHER_REDIRECT_URI
    )}`,
    homeUrl: '/',
    homeUrlFn: hostname => `https://${hostname}/login?provider=ul`,
    supportEmail: 'de-support@focusvision.com'
  },
  {
    id: 'revelation',
    title: 'Digital Diaries',
    displayOnHomepage: true,
    loginUrl: '/login?client_id=revelation',
    loginUrlFn: hostname => hostname.match(/studyspace|fvdev\.net/) ?
      `https://researcher.${hostname}` :
      `https://researcher.${hostname}/revelation`,
    homeUrl: 'https://researcher.studyspace.net/',
    homeUrlFn: hostname => hostname.match(/studyspace|fvdev\.net/) ?
      `https://researcher.${hostname}` :
      `https://researcher.${hostname}/revelation`,
    zendeskHost: 'revelation.zendesk.com',
    supportEmail: 're-support@focusvision.com'
  },
  {
    id: 'vi',
    title: 'Video Insights',
    displayOnHomepage: true,
    loginUrl: process.env.REACT_APP_VI_LOGIN_URI,
    signupUrl: baseQueryString => `/sign-up${baseQueryString}`,
    homeUrl: process.env.REACT_APP_VI_HOME_URI,
    loginUrlFn: hostname => `https://${hostname}/login`,
    homeUrlFn: hostname => `https://${hostname}`,
    confirmationUri: '/login/confirmation',
    zendeskHost: 'focusvision.zendesk.com',
    supportEmail: 'vi-support@focusvision.com',
    ssoSignUp: true
  },
  {
    id: 'kinesis',
    title: 'Panel Management',
    displayOnHomepage: true,
    loginUrl: '/login?client_id=kinesis',
    homeUrl: '/',
    homeUrlFn: hostname =>
      `${
        process.env.NODE_ENV === 'development' ? 'http' : 'https'
      }://${hostname}/auth.pro`,
    supportEmail: 'kp-support@focusvision.com'
  },
  {
    id: 'VideoStreaming',
    title: 'Forsta Vision & InterVu',
    displayOnHomepage: true,
    loginUrl: process.env.REACT_APP_VIDEO_STREAMING_LOGIN_URI,
    signupUrl: `/sign-up?client_id=VideoStreaming&confirmation_uri=/login/confirmation&hostname=${
      process.env.REACT_APP_VIDEO_STREAMING_HOSTNAME
    }`,
    homeUrl: '/',
    confirmationUri: '/login/confirmation',
    supportEmail: 'support@forsta.com',
    ssoSignUp: true
  },
  {
    id: 'intervu',
    title: 'Digital Interviews',
    displayOnHomepage: false,
    loginUrl: 'https://iv.focusvision.com/',
    homeUrl: '/',
    supportEmail: 'support@focusvision.com'
  },
  {
    id: 'intervunow',
    homeUrl: process.env.REACT_APP_INTERVU_HOME_URI,
    homeUrlFn: () => process.env.REACT_APP_INTERVU_HOME_URI,
    confirmationUri: '/login/confirmation',
    displayOnHomepage: false
  },
  {
    id: 'explore',
    title: 'Explore Forsta Discussions',
    displayOnHomepage: true,
    loginUrl: 'https://demo.forsta.com/discussions'
  }
]

export const findPlatform = platformId =>
  platforms.find(platform => platform.id === platformId)

export default platforms



// WEBPACK FOOTER //
// ./src/config/platforms.js